import { getSimpleVueHorizontalScroll } from '../vue/horizontal-scroll';

const elements = cr$.byClass('horizontal-scroll-vue');

requestIdleCallback(() => {
    elements.each((el) => {
        getSimpleVueHorizontalScroll(el);
    });
});
